const NAMESPACE = "tagList";

const KEYS = {
    tagListLabel: "tagListLabel",
    customListGroupTagsText: "customListGroupTagsText",
    tagsNotSupportedText: "tagsNotSupportedText",
    deadlineTemplateTagsSupportLinkText: "deadlineTemplateTagsSupportLinkText"
};

const MESSAGES = {
    [KEYS.tagListLabel]: {
        value: "Template Tags:|Template Tag:|Template Tags:",
        comment: "Label for list of template tags"
    },
    [KEYS.tagsOnDataFieldGroupText]: {
        value: "See {dataFieldGroupName} on the Data Field Groups tab",
        comment: "Text referring user to the Data Field Group to find tags"
    },
    [KEYS.customListGroupTagsText]: {
        value: "See the Data Fields tab for template tags.",
        comment: "Custom Group text directing user to Data Fields tab."
    },
    [KEYS.tagsNotSupportedText]: {
        value: "Template tags not supported.",
        comment: "Info text explaining that template tags aren't supported."
    },
    [KEYS.deadlineTemplateTagsSupportLinkText]: {
        value: "Learn about additional deadline template tags and their use",
        comment: "Text linking to the support center information on deadline template tags"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
